export const info = {
  product: {
    noRecords: 'There are no products to display',
  },
};
